module.exports = __webpack_public_path__ + "b7de62572ebbd02edb55b97fea662cda.svg";